// extracted by mini-css-extract-plugin
export default {"box":"CheckingInfoBox_box__GV7nt"};